<template>
  <div class="back_top">
    <div :class="{right_menu:true,isfixed:isFixed}">
      <div class="item" v-for="(v,i) in rightMenu" :key="i" @click="handClick(v.name)">
        <div class="show" v-show="v.showItem">
          <div class="img">
            <el-badge v-if="v.name==='购物车'" class="cart" :value="shoppingCartList.length" :max="99">
              <img v-lazy="v.src" />
            </el-badge>
            <img v-else v-lazy="v.src" />
          </div>
          <h5>{{v.name}}</h5>
          <div class="qrcode" v-if="v.assetsImg">
            <img :src="v.assetsImg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetShopCartList } from "@/pages/page1/api/modules/shoppingCart";
const dataMenu = [
  {
    name: "客服1",
    src: require("@/assets/img/rightMenu11.png"),
    assetsImg: require("@/assets/img/kefu1.png"),
    showItem: true,
  },
  {
    name: "客服2",
    src: require("@/assets/img/rightMenu11.png"),
    assetsImg: require("@/assets/img/kefu2.png"),
    showItem: true,
  },
  // {
  //   name: "体验馆",
  //   src: require("@/assets/img/rightMenu2.png"),
  //   assetsImg: "",
  // },
  {
    name: "购物车",
    src: require("@/assets/img/rightMenu3.png"),
    assetsImg: "",
    showItem: true,
  },
  {
    name: "小程序",
    src: require("@/assets/img/rightMenu4.png"),
    assetsImg: require("@/assets/img/qrCode2.png"),
    showItem: true,
  },
  {
    name: "公众号",
    src: require("@/assets/img/rightMenu5.png"),
    assetsImg: require("@/assets/img/qrCode3.jpg"),
    showItem: true,
  },
  {
    name: "返回顶部",
    src: require("@/assets/img/rightMenu6.png"),
    assetsImg: "",
    showItem: false,
  },
];
export default {
  data() {
    return {
      rightMenu: dataMenu,
      isFixed: true,
      shoppingCartList: [],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if (this.$cookies.isKey("ACCESS_TOKEN")) {
      this.getShoppingCart();
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 页面被卷去的上高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //   console.log(scrollTop);
      // this.isFixed = scrollTop >= 1200 ? true : false;
      if (scrollTop > 1200) {
        this.rightMenu[5].showItem = true;
      } else {
        this.rightMenu[5].showItem = false;
      }
    },
    handClick(name) {
      if (name === "购物车") {
        this.goRequirePage("/shopCart");
      }
      if (name === "返回顶部") {
        window.scrollTo({
          left: 0,
          top: 0,
          // behavior: "smooth",
        });
      }
    },
    // 去需要登录的页面
    goRequirePage(path) {
      if (this.$cookies.isKey("ACCESS_TOKEN")) {
        let newUrl = this.$router.resolve(path);
        window.open(newUrl.href, "_blank");
      } else {
        this.goWithRedirect(path);
      }
    },
    // 去登录页 或者注册页带重定向地址
    goWithRedirect(path, register) {
      let newUrl = this.$router.resolve({
        path: register ? "/register" : "/login",
        query: {
          redirect: path,
        },
      });
      window.open(newUrl.href, "_self");
    },
    getShoppingCart() {
      GetShopCartList({}).then((res) => {
        let arr = [];
        // console.log("获取购物车列表", res);
        res.data.forEach((v) => {
          v.shoppingCartList.forEach((item) => {
            arr.push(item);
          });
        });
        this.shoppingCartList = arr;
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media (max-width: 1468px) {
  .right_menu {
    display: none !important;
  }
}
.right_menu {
  // display: none;
  right: calc((100% - 1190px) / 2 / 2);
  z-index: 30;
  .item {
    .show {
      width: 64px;
      height: 64px;
      background: #ffffff;
      box-shadow: 0px 2px 3px 0px rgba(4, 0, 0, 0.2);
      margin-bottom: 2px;
      cursor: pointer;
      position: relative;
      .img {
        width: 100%;
        text-align: center;

        position: absolute;
        bottom: 24px;
        left: 0;
        img {
          width: auto;
          height: auto;
        }
      }
      h5 {
        font-size: 12px;
        font-weight: 400;
        color: #535353;

        width: 100%;
        text-align: center;

        position: absolute;
        bottom: 6px;
        left: 0;
      }
      .qrcode {
        position: absolute;
        right: 100%;
        top: 0;
        margin-right: 16px;
        box-sizing: border-box;
        padding: 8px;
        background: #ffffff;
        border-radius: 6px;
        box-shadow: 0 0 5px 2px #ececec;
        display: none;
        img {
          width: 210px;
          height: 210px;
        }
        &::after {
          display: block;
          content: "";
          width: 0;
          height: 0;
          position: absolute;
          left: 100%;
          top: 20px;
          border-width: 5px 5px;
          border-style: solid;
          border-color: transparent transparent transparent #ffffff;
        }
      }
      &:hover {
        h5 {
          color: @themeColor;
        }
        .qrcode {
          display: block;
        }
      }
    }
  }
}
.isfixed {
  position: fixed;
  top: 50%;
  margin-top: -100px;
  // display: block;
}
/deep/ .el-badge {
  .el-badge__content {
    min-width: 10px;
    height: 14px;
    line-height: 14px;
    padding: 0 2px;
    border: none;
  }
  .el-badge__content.is-fixed {
    top: 8px;
    right: 12px;
  }
}
</style>